<template>
	<UserRegistrationLayout showProgressBar class="signed-up-successfull">
		<div class="display-flex flex-column">
			<div class="slot-title">You’re almost there</div>
			<div class="description-text disaply-flex flex-row flex-align-center mt-4">
				We just sent you an email with a <br />
				confirmation code to
				<span class="email-text">{{ userEmail }}</span>
			</div>
			<div class="otp-text mt-9">Please fill the code below:</div>
			<div class="otp-input-container display-flex flex-row">
				<v-otp-input :error="isWrongCode" :disabled="isLoading" @finish="isCodeAuthenticated" type="number" length="6"></v-otp-input>
			</div>
			<div v-if="isWrongCode" class="otp-error-message">Wrong Code</div>
			<div class="otp-loader-container display-flex flex-column">
				<Loader v-show="isLoading" />
			</div>
			<div class="bottom-section">
				<div v-if="!isEmailResent">
					Didn’t get an email?
					<span @click="sendAnotherCode()" class="primary-link-style ml-1">Resend code</span>
				</div>
				<div v-else>
					<div>We've just sent you another email with a confirmation code</div>
					<span @click="sendAnotherCode" class="primary-link-style ml-1">Resend code</span>
				</div>
			</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UserRegistrationLayout from './UserRegistrationLayout';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';
import UserRegistrationService from './helpers/UserRegistrationService';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'SignedUpSuccessfull',
	components: {
		UserRegistrationLayout,
	},
	computed: {
		...mapGetters(['user']),
		userEmail() {
			return this.$route.params.userEmail;
		},
		pendingInstallationId() {
			return this.user?.profile?.metadata?.pending_installations?.[0];
		},
	},
	methods: {
		...mapActions(['verifyOTP']),
		...mapActions(['getUser']),
		isPendingInstallationInProgress() {
			return Boolean(this.pendingInstallationId);
		},

		async isCodeAuthenticated(otp) {
			this.isLoading = true;
			const isAuthenticated = await this.verifyOTP({ otp, email: this.userEmail });
			this.isLoading = false;
			if (!isAuthenticated) {
				this.isWrongCode = true;
				return;
			}
			this.isWrongCode = false;
			if (this.isPendingInstallationInProgress()) {
				await AppDialogManagerService.openContinueInstallationSignupDialog();
			}
			if (this.user.profile.account) {
				const { signup_referrer } = this.user.profile.metadata;
				const navigateTo = await UserRegistrationService.getNavigateToFirstPageObject(signup_referrer, this.$route.query.return_to);
				this.navigateTo(navigateTo);
			} // else it will redirect from actions to WORKSPACE_SELECTION_ROUTE_NAME
		},
		sendAnotherCode() {
			this.resendEmail(true);
			this.isEmailResent = true;
		},
	},
	data() {
		return {
			isLoading: false,
			isWrongCode: false,
			isEmailResent: false,
		};
	},
	mounted() {
		if (!this.userEmail) {
			this.navigateTo({ name: 'Signup' });
		}
		if (this.$route.params.resendEmail) {
			this.resendEmail(true);
		}
	},
	mixins: [UserRegistrationMixin],
};
</script>

<style scoped lang="scss">
.description-text {
	font-weight: 300;
	font-size: 16px;
	color: var(--primary-font-color);
}
.signed-up-successfull {
	.otp-error-message {
		font-size: 12px;
		color: #de2928;
		text-align: left;
	}

	.otp-text {
		font-size: 18px;
		text-align: center;
		padding-bottom: 10px;
		color: var(--primary-font-color);
	}

	.otp-loader-container {
		height: 80px;
	}

	.otp-input-container {
		::v-deep {
			.v-text-field__slot {
				height: 91px;
				padding: 0px;
				max-width: 70px;
				box-shadow: 0px 3px 10px #00000029;
			}
			.v-input__slot {
				min-height: 91px !important;
			}
		}
	}

	.right-side-section {
		.slot-title {
			margin: 30px 0 40px;
		}
	}

	.email-text {
		color: var(--primary-color);
	}
}

.bottom-section {
	font-size: 14px;
	margin-top: 150px;
}
</style>
